import { ReactiveMap } from "@solid-primitives/map"
import type { EntityGraphNode } from "../../lib/core/engine/EntityGraphNode/EntityGraphNode.type"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export type EntityByXYIndexReactiveMap = ReactiveMap<number, Array<EntityGraphNode>>

export const useEntityByXYIndexReactiveMap = createSharedCachedFactory((
  // engine: Engine
): EntityByXYIndexReactiveMap => {
  const map = new ReactiveMap<number, Array<EntityGraphNode>>()
  return map
})
